import React from 'react';
import SimpleHeader from './SimpleHeader';
import Footer from './Footer';
import Loader from "../components/common/Loading";

const LoadingPage = () => {
  return (
    <div className="min-h-full">
      <SimpleHeader />

      <main className="-mt-24 bg-gray-100">
        <div className="mx-auto px-4 pb-32 sm:px-6 lg:px-8">
          <div className="min-height-content bg-gray-100 ">
            <div className="flex-grow flex min-height-content justify-center items-center bg-gray-100">
              <Loader />
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default LoadingPage;
